// @flow
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText } from "@mui/material";
import React from "react";
export const MyCheckbox = (props) => {
  return (
    <>
      <FormControl error={props.helperText != ""} component="fieldset" fullWidth style={{margin: "1rem 0", ...props.formControlStyle  }} className={props.className}>
        <FormGroup>
          <FormControlLabel
            style={{ width: "100%", marginBottom: "0", ...props.style }}
            control={<Checkbox checked={props.checked} onChange={(e) => props.onChange(e.target.checked)} />}
            label={props.label}
          />
        </FormGroup>
        {props.helperText && <FormHelperText>{props.helperText}</FormHelperText>}
      </FormControl>
    </>
  );
};
